import * as React from 'react';

import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import { getWidth } from '@components/styles';
import ButtonCounter from '@components/button-counter';
import ButtonFixed from '@components/layout/button-fixed';

interface CounterFixedButtonProps {
  className?: string;
  isValid?: boolean;
  label?: React.ReactNode;
  fixed?: boolean;
  bottomMargin?: string;
  isMobile?: boolean;
  currentStep: number;
  maxStep: number;
  customMaxStep?: number;
  isLoading?: boolean;
  disableLoader?: boolean;
  customLabel?: React.ReactNode;
  customDisabledLabel?: React.ReactNode;
  onNext: () => void;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const CounterFixedButton: React.FC<CounterFixedButtonProps> = ({
  className,
  isValid,
  label,
  fixed,
  bottomMargin,
  isMobile,
  currentStep,
  maxStep,
  customMaxStep,
  isLoading,
  disableLoader,
  customLabel,
  customDisabledLabel,
  onNext,
}) => {
  const [step, setStep] = React.useState(1);

  React.useEffect(() => {
    setStep(currentStep);
  }, [currentStep]);

  const getLabel = () => {
    if (label) {
      return label;
    }

    return <Translate id="BUTTON.COMMON.NEXT_STEP" />;
  };

  return (
    <ButtonFixed
      className={className}
      fixed={fixed === undefined ? true : fixed}
      noPadding
      bottomMargin={bottomMargin || undefined}
    >
      <ButtonCounter
        className="btn-counter"
        disabled={!isValid}
        current={currentStep || step}
        max={maxStep}
        customMax={customMaxStep}
        isLoading={isLoading}
        disableLoader={disableLoader}
        onClick={onNext}
      >
        {customLabel ? (
          customLabel
        ) : !isValid && isMobile ? (
          customDisabledLabel ? (
            customDisabledLabel
          ) : (
            <Translate id="BUTTON.COMMON.FILL_FIELDS" />
          )
        ) : (
          getLabel()
        )}
      </ButtonCounter>
    </ButtonFixed>
  );
};

export default connect(mapStateToProps)(styled(CounterFixedButton)`
  z-index: ${({ theme }) => theme.zIndices.dialogs};

  .btn-counter {
    min-height: 70px;
    margin: 0 auto;
    max-width: calc(100% - 48px);

    @media ${({ theme }) => theme.device.tablet} {
      width: ${getWidth(3)};
    }

    ${(props) =>
      props.isMobile &&
      `
      position: fixed;
      bottom: 0;
      right: 20px;
      width: 70%;
    `}
  }
`);
